import RewardsSection from './RewardsSection.vue'

export default RewardsSection
